import { Injectable } from '@angular/core';
import { MaterialCategoryDTO } from '@scip/api';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { MaterialCategoryControllerService } from '@scip/api';

@Injectable({
  providedIn: 'root'
})
export class MaterialCategoryService {
  // Lets load the categories from the backend, but only once per ui-session
  private readonly allMaterialCategories: Observable<MaterialCategoryDTO[]> = this.matCatService.getAllMaterialCategories1().pipe(shareReplay(1));

  constructor(private matCatService: MaterialCategoryControllerService) {}

  getAllMaterialCategories(): Observable<MaterialCategoryDTO[]> {
    return this.allMaterialCategories;
  }
}
